



























































































































































































































































































import { UNIT_SEARCH } from '@/queries/Unit';
import { Component, Vue, Prop, Emit, Ref } from 'vue-property-decorator';
import { IRules } from '../UI/Form/ValidationModule';
import { validateRequired, validateType } from '../UI/Form/Validations';
import { SmartQuery } from 'vue-apollo-decorator';
import { GQL_DeliveryLocationSave, GQL_CustomerContactCreate, GQL_CustomerContactUpdate, GQL_CustomerUpdate } from '@/queries/global';
import { GQL_createUnit_createUnit_unit } from '@/queries/__generated__/createUnit';
import { GQL_unitSearch_unitSearch } from '@/queries/__generated__/unitSearch';
import { UNIT_INVOICE_SETTINGS } from '@/queries/CompanySetting';
import { GQL_unitInvoiceSetting_currentUnit } from '@/queries/__generated__/unitInvoiceSetting';
import DeepCopy from '@/decorators/deep-copy';
import UnitForm from './UnitForm.vue';
import SApolloAutocomplete from '@/components/UI/Form/Autocomplete/SApolloAutocomplete.vue';
import CustomerFormDeliveryLocations from './CustomerFormDeliveryLocations.vue';
import CustomerFormCustomerContacts from './CustomerFormCustomerContacts.vue';
import { WithUID } from '@/utils/utils';
import { GQL_updateCustomerVariables } from '@/queries/__generated__/updateCustomer';
import { CUSTOMER_LIST_SEARCH } from './customerListSearch';
import { EFAKTURA_CUSTOMER_NUMBER_LENGTH } from '@/app/Invoice';
import UnitClosingDatesInfo from '../Unit/UnitClosingDatesInfo.vue';
import { GQL_customerListSearch, GQL_customerListSearch_customers } from '@/queries/__generated__/customerListSearch';

@Component({
  components: {
    UnitForm,
    CustomerFormDeliveryLocations,
    CustomerFormCustomerContacts,
    UnitClosingDatesInfo,
  },
})
export default class CustomerForm extends Vue {
  @SmartQuery(UNIT_INVOICE_SETTINGS) private currentUnit!: GQL_unitInvoiceSetting_currentUnit;

  @SmartQuery<CustomerForm, GQL_customerListSearch>({
    query: CUSTOMER_LIST_SEARCH,
    skip() { return !this.unitId },
    variables() {
      return { limit: 1, filters: { unitId: this.unitId }};
    },
    update: data => data.customers[0],
    fetchPolicy: "no-cache",
  }) private existingCustomer!: GQL_customerListSearch_customers;

  private closeUnitForm(unit: GQL_createUnit_createUnit_unit) {
    this.showUnitForm = false;
    this.customerAutocompleteRef.data = [ unit ];
    this.customerAutocompleteRef.autocompleteRef.selectOption(unit);
  }

  public UNIT_SEARCH = UNIT_SEARCH;
  private today = this.$dayjs().format('YYYY-MM-DD');

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @DeepCopy('data') private formData!: any;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Prop(Object) public data!: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Prop(Object) public query!: any;

  @Ref() private customerAutocompleteRef!: SApolloAutocomplete<GQL_unitSearch_unitSearch>;
  @Ref() private customerFormDeliveryLocations!: CustomerFormDeliveryLocations;
  public unitId: string | null = null;

  public validForm = true;

  private showUnitForm = false;

  private get efakturaAvailable(): boolean {
    return !!this.currentUnit?.unitSetting?.unitInvoiceSetting?.efakturaEnabled;
  }

  private get customerNumberMaxLength(): number {
    return EFAKTURA_CUSTOMER_NUMBER_LENGTH;
  }

  public rules: IRules = {
    unitId: [ {
      validation: validateRequired(),
      message: i18n => i18n.t('Error.required', { field: i18n.t('Customer.customer') }),
    } ],
    deliveryAddress: [ {
      validation: validateRequired(),
      message: i18n => i18n.t('Error.required', { field: this.t_attr('DeliveryLocation', 'address') }),
    } ],
    deliveryZip: [ {
      validation: validateRequired(),
      message: i18n => i18n.t('Error.required', { field: this.t_attr('DeliveryLocation', 'zip') }),
    } ],
    deliveryCity: [ {
      validation: validateRequired(),
      message: i18n => i18n.t('Error.required', { field: this.t_attr('DeliveryLocation', 'city') }),
    } ],
    deliveryCountryCode: [ {
      validation: validateRequired(),
      message: i18n => i18n.t('Error.required', { field: this.t_attr('DeliveryLocation', 'country') }),
    } ],
    creditDays: [
      {
        validation: validateRequired(),
        message: i18n => i18n.t('Error.required', { field: this.t_attr('Customer', 'creditDays') }),
      },
      {
        validation: validateType('uint'),
        message: i18n => i18n.t('GQL.Type.uint'),
      },
    ],
    customEmail: [ {
      validation: validateType('email'),
      message: i18n => i18n.t('Error.email'),
    } ],
    invoiceDeliveryMethod: [ {
      validation: validateRequired(),
      message: i18n => i18n.t('Error.required', { field: this.t_attr('Customer', 'invoiceDeliveryMethod') }),
    } ],
    contact: {
      firstName: [ {
        validation: validateRequired(),
        message: i18n => i18n.t('Error.required', { field: this.t_attr('CustomerContact', 'firstName') }),
      } ],
      lastName: [ {
        validation: validateRequired(),
        message: i18n => i18n.t('Error.required', { field: this.t_attr('CustomerContact', 'lastName') }),
      } ],
    },
  };

  public created() {
    this.unitId = this.formData.unit?.id || null;
  }

  public formatData(data: GQL_CustomerUpdate): GQL_updateCustomerVariables {
    return {
      customer: {
        ...data,
        deliveryLocations: data.deliveryLocations!.map(location => {
          return {
            ...location,
            country: undefined,
            $_expandableId: undefined,
            $_UID: undefined,
          };
        }),
        customerContacts: data.customerContacts!.map(contact => {
          return {
            ...contact,
            $_expandableId: undefined,
            $_UID: undefined,
          };
        }),
        unitId: this.unitId,

        // Read-only fields the customer fragment brings along: the server derives them,
        // and CustomerUpdate has no arguments for them.
        unit: undefined,
        email: undefined,
        phone: undefined,
        efakturaEligible: undefined,
        efakturaIdentifier: undefined,
      } as GQL_CustomerUpdate,
    };
  }

  public updateUnitData(item: GQL_unitSearch_unitSearch) {
    // eslint-disable-next-line no-prototype-builtins
    if (!item.hasOwnProperty('id')) return;

    this.formData.unit = item;
    this.formData.unofficialName = item.unofficialName;
    this.formData.creditDays = this.currentUnit.unitSetting.unitInvoiceSetting.customerCreditDays;

    // We clone the array before looping so forEach does not skip removed elements.
    [ ...this.formData.deliveryLocations ].forEach((delivery: WithUID<GQL_DeliveryLocationSave>) => {
      this.customerFormDeliveryLocations.removeDeliveryLocation(delivery);
    });

    const deliveryLocation: GQL_DeliveryLocationSave = {
      id: undefined,
      address: item.address,
      zip: item.zip,
      city: item.city,
      countryCode: item.country.code,
      _destroy: undefined,
    };
    this.formData.deliveryLocations.push(deliveryLocation);

    // We clone the array before looping so forEach does not skip removed elements.
    [ ...this.formData.customerContacts ].forEach((contact: WithUID<GQL_CustomerContactCreate | GQL_CustomerContactUpdate>) => {
      this.customerFormDeliveryLocations.removeDeliveryLocation(contact);
    });

    if (!item.isCompany) {
      this.formData.reference = item.name;
    }

    if (item.canReceiveEhf3) {
      this.formData.invoiceDeliveryMethod = "ehf";
    } else {
      this.formData.invoiceDeliveryMethod = null;
    }
  }

  @Emit()
  public mutationDone() {}

  private get canSave(): boolean {
    return (
      this.validForm &&
      this.formData.deliveryLocations.some((delivery: GQL_DeliveryLocationSave) => !delivery._destroy)
    );
  }
}
